import { render } from "./ShowPatient.vue?vue&type=template&id=3118c3eb&scoped=true"
import script from "./ShowPatient.vue?vue&type=script&lang=js"
export * from "./ShowPatient.vue?vue&type=script&lang=js"

import "./ShowPatient.vue?vue&type=style&index=0&id=3118c3eb&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3118c3eb"]])

export default __exports__